"use client";

import { InfoItem } from "@/components/discover/InfoItem";
import { useNow } from "@/hooks/useNow";
import {
  formatDetailedEventDate,
  hasTimeComponent,
  isMidnightInZone,
} from "@/utils/date";
import { computeRegistrationDeadlineBadge } from "@/utils/registrationDeadline";
import { Info } from "lucide-react";

export function RegistrationDeadline(props: {
  registrationDeadline?: string | null;
  label: string;
  dayLeft: string;
  daysLeft: string;
  hourLeft: string;
  hoursLeft: string;
  locale?: string;
  timeZone?: string;
}) {
  const now = useNow();
  if (!props.registrationDeadline) return null;

  const { showBadge, count, unit } = computeRegistrationDeadlineBadge(
    props.registrationDeadline,
    now,
  );
  const unitLabel =
    unit === "hour"
      ? count === 1
        ? props.hourLeft
        : props.hoursLeft
      : count === 1
        ? props.dayLeft
        : props.daysLeft;

  return (
    <InfoItem icon={Info} label={props.label}>
      <div className="flex items-center gap-2">
        <span>
          {formatDetailedEventDate({
            locale: props.locale || "en-gb",
            date: props.registrationDeadline,
            // Only show a time when the value carries a meaningful one:
            // legacy docs may be date-only, and a midnight deadline means
            // "by that day", not literally 00:00.
            includeTime:
              hasTimeComponent(props.registrationDeadline) &&
              !isMidnightInZone(props.registrationDeadline, props.timeZone),
            timeZone: props.timeZone,
          })}
        </span>
        {showBadge && (
          <span className="rounded-md px-2 py-0.5 text-xs font-semibold bg-destructive text-primary-foreground">
            {count} {unitLabel}
          </span>
        )}
      </div>
    </InfoItem>
  );
}
